import { Component, computed, inject } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

import { AlertSeverityComponent } from '../../../alerts/components/alert-severity/alert-severity.component';
import { AlertsFacade } from '../../../alerts/facades/alerts.facade';
import { ALERT_SEVERITY } from '../../../alerts/models/Alert';

@Component({
    selector: 'app-alert-indicator',
    imports: [AlertSeverityComponent, TranslatePipe],
    templateUrl: './alert-indicator.component.html',
    styleUrl: './alert-indicator.component.scss',
})
export class AlertIndicatorComponent {
    private readonly alertsFacade = inject(AlertsFacade);

    ALERT_SEVERITY = ALERT_SEVERITY;

    protected readonly newAlertCounts = computed(() => {
        const { high, normal } = this.alertsFacade.newAlertsBySeverity();
        return { high, normal, total: high + normal };
    });
}
